export default {
  'otp.oldPrice': '元の価格',
  'otp.details': '期間限定無料キャンペーン詳細',
  'otp.effective': '有効時間',
  'otp.userTitle': '対象ユーザー',
  'otp.tip': 'EngageLab他製品をご利用中でOTP未チャージの場合でも、本キャンペーン対象となります。',
  'otp.service.dsc': 'OTP製品チャージサービス初回利用者。',
  'otp.event': 'イベント',
  'otp.tip1a': 'プロモーション期間中、初回OTPチャージを行ったユーザーは、チャージ日から',
  'otp.tip1b': '30日間',
  'otp.tip1c': 'のOTP認証料金が免除されます。',
  'otp.notes1': '1. 本キャンペーンは1アカウントにつき1回限りのご参加となります',
  'otp.notes2': '2. チャージ完了後の返金は一切受け付けておりません。ご不明な点がございましたら、',
  'otp.notes2a': 'お問い合わせ',
  'otp.notes2b': 'ください。',
  'otp.notes3': '3. 法律の範囲において、本キャンペーンの最終解釈権はEngageLabが有します',
  'email.sem.title': 'Limited Time Offer! 500 Free Emails/day for New Users',
  'email.sem.btn': 'Start Now',
};
